// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"5467":"cd1c1b14d0d994945c74","6132":"dc968f3f5efb47e67e48"}[chunkId] + ".js";
};